<template>
  <v-container class="pt-5">
    <v-flex xs12 sm6 offset-sm3>
      <v-layout row align-center justify-center>
        <v-flex class="hidden-sm-and-down">
          <v-card
            height="402px"
            :img="require('../assets/login_img400.jpg')"
          ></v-card>
        </v-flex>
        <v-flex>
          <v-container class="text-xs-center black pa-1">
            <v-card class="pa-4" flat>
              <v-card-title primary-title>
                <h2>Login</h2>
              </v-card-title>
              <v-form>
                <v-text-field
                  outline
                  prepend-icon="person"
                  name="Username"
                  :label="$t('username')"
                  v-model="username"
                  :error-messages="userErrors"
                  required
                  @input="$v.username.$touch()"
                  @blur="$v.username.$touch()"
                ></v-text-field>
                <v-text-field
                  outline
                  prepend-icon="lock"
                  name="Password"
                  :label="$t('password')"
                  type="password"
                  v-model="password"
                  :error-messages="pwdErrors"
                  required
                  @input="$v.password.$touch()"
                  @blur="$v.password.$touch()"
                  @keyup.enter="login"
                ></v-text-field>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn primary large offset-xs3 @click="login">{{
                    $t('login')
                  }}</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
            <v-card flat>
              <span>
                {{ $t('havent_account') }}?
                <router-link to="/register">{{
                  $t('register_self')
                }}</router-link>
              </span>
              <br />
              <span>
                {{ $t('problem_password') }}?
                <router-link to="/reset">{{
                  $t('reset_password')
                }}</router-link>
              </span>
            </v-card>
          </v-container>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>
<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  validations: {
    username: { required, email },
    password: { required }
  },
  name: 'login',
  data() {
    return {
      username: null,
      password: null,
      bgimg: '../assets/login_img400.jpg'
    }
  },

  methods: {
    login() {
      if (this.invalidForm) {
        return
      }
      this.$root.$loader(true)
      this.$auth.login({
        url: this.$providerURL + '/Api/Access/LoginUser',
        headers: {
          'Content-Type': 'application/json',
          Check: '156C3B1E-514E-4C6D-B257-908E30860A23'
        },

        data: { Password: this.password, UserName: this.username },
        success: function() {
          this.$root.$loader(false)

          let redirectTo =
            this.$auth.user().UserLevel === 2
              ? 'ecrmregistration'
              : 'dealers_mgmt'

          this.$router.push({ name: redirectTo })
        },
        error(error) {
          switch (error.response.data.Code) {
            case 106:
              this.$root.$gerror({ Code: 106, Message: this.$t('_106') })
              break
            default:
              this.$root.$gerror(error.response.data)
          }
          this.$root.$loader(false)
        }
      })
    }
  },
  computed: {
    userErrors() {
      const errors = []
      if (!this.$v.username.$dirty) return []
      !this.$v.username.email && errors.push(this.$t('email_must_be_valid'))
      !this.$v.username.required && errors.push(this.$t('email_is_required'))
      return errors
    },
    pwdErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return []
      !this.$v.password.required && errors.push(this.$t('passwd_is_required'))
      return errors
    },
    invalidForm() {
      this.$v.$touch()
      return this.$v.$invalid
    }
  }
}
</script>
<style lang="css">
.border-black {
  border-color: black;
}
</style>
